export interface PrecioCliente {
  id: number;
  idCliente: number;
  idPresentacion: number;
  idCalibre: number;
  tipoProceso: string;
  precioMateriaPrima: number;
  precioServicio: number;
  fechaActualizacion: string;
  activo: boolean;
  presentacion?: {
    idPresentacion: number;
    descripcion: string;
  };
  calibre?: {
    idCalibre: number;
    descripcion: string;
  };
}

export interface PrecioClienteState {
  precios: PrecioCliente[];
  loading: boolean;
  error: string | null;
}

export interface SaveBulkRequest {
  idCliente: number;
  tipoProceso: string;
  precios: PrecioCliente[];
}

export const TIPOS_PROCESO = {
  options: ['COMPRA', 'SERVICIO'] as const,
};
